<template>
    <div class="m-main-exp">
        <div class="title"></div>

        <div class="page-view">
            <div class="gif-view">
                <div class="img">
                    <img src="https://web-resource.17m3.com/m3guo/202602/ck/this.gif">
                </div>
                
                <div class="u-btn player" v-video="'203ebf0e121a71f19d6a5107e0c90102'">
                    <p>（查看皮肤演示视频）</p>
                </div>

                <div class="layer-border"></div>
            </div>
            
            <div class="intro">
                <p>3月19日-4月15日，参与娱乐*三国无双/天命*荆州争霸/英霸官渡/英霸*天命无双地图/军团出征/军团出征*巅峰，每局活动结束后所获得的军威值将以1:1转化为经验值，天命*荆州争霸额外增加20%经验！</p>
            </div>  
            
            <div class="pass-599">
                <div class="pass-img">
                    <div class="u-btn detail" @click="$pass_detail()"></div>
                </div>
                <div class="u-btn apply-599" :class="{'dismiss' : ($store.state.userinfo.uflag & 2) == 2}" @click="buy_599pass()"></div>
            </div>

            <div class="exp-pannel">
                <div class="tab-hd">
                    <div class="tab-btn u-btn t-1" :class="{'active' : nav_index == 1}" @click="nav_index = 1;"></div>
                    <div class="tab-btn u-btn t-2" :class="{'active' : nav_index == 2}" @click="nav_index = 2;"></div>
                </div>

                <div class="t-exp" v-if="nav_index == 1">

                    <div class="wrapper">
                        <div class="m-exp">
                            <div class="data-info flex-between-center">
                                <span class="exp-info">累计获取经验值：{{ $global.formatNum($store.state.task[tid].rate,max_exp) || 0 }}/{{ max_exp }}</span>

                                <div class="uis flex-start-center">
                                    <div class="u-btn score" @click="query_score()"></div>
                                    <div class="u-btn u-rule" @click="$evt_rule()"></div>
                                </div>
                            </div>

                            <div class="exp-bar">
                                <div class="bar">
                                    <div class="bar-rate" :style="{'width' : max_format() + '%'}"></div>
                                </div>
                            </div>

                            <div class="time-info" :class="{'over' : $store.state.login}">
                                <div class="time">
                                    <span id="J-end">活动截止时间：4月15日</span>
                                </div>
                                <div class="time">领取兑换截止时间：4月17日</div>
                            </div>
                        </div>

                        <div class="passport-view">
                            <div class="table-head">
                                <div class="icon-lock" v-if="($store.state.userinfo.uflag & 2) != 2"></div>
                            </div>
                            <div class="data-table list-table">
                                <table>
                                    <tbody id="J-reward">
                                        <tr v-for="(item,index) in $store.state.task[tid].subList.slice(now_page * perpage , perpage * (now_page + 1))" :key="index">
                                            <th class="exp">{{ item.value }}</th>
                                            <th class="r">
                                                <div class="reward-pic" :class="{'dismiss' : $store.state.userinfo.areaId && ($store.state.task[tid].giftRate > (now_page * perpage + index))}" v-tips="item.giftList[0].gameGiftId">
                                                    <game-item :id="item.giftList[0].gameGiftId" :num="item.giftList[0].sendNum" :locked="true"></game-item>
                                                </div>                               
                                            </th>
                                            <th class="r-ex">                                          
                                                <div class="reward-pic" :class="{'dismiss' : $store.state.userinfo.areaId && ($store.state.task[tid_pass].giftRate > (now_page * perpage + index))}" v-tips="$store.state.task[tid_pass].subList[now_page * perpage + index].giftList[0].gameGiftId">
                                                    <div class="icon-lock" v-if="($store.state.userinfo.uflag & 2) != 2"></div>
                                                    <game-item :id="$store.state.task[tid_pass].subList[now_page * perpage + index].giftList[0].gameGiftId" :num="$store.state.task[tid_pass].subList[now_page * perpage + index].giftList[0].sendNum" :locked="true"></game-item>
                                                </div>                             
                                            </th>
                                        </tr>
                                    </tbody>
                                </table>

                                
                                <div class="pages-ui">
                                    <div class="u-btn page prev" @click="prev" :class="{'disabled' : now_page == 0}"></div>
                                    <div class="page-item" v-for="n in 4" :key="n" :class="{'act' : now_page == n - 1}" @click="page(n - 1)">{{ n }}</div>
                                    <div class="u-btn page next" @click="next" :class="{'disabled' : now_page == 3}"></div>
                                </div>
                                
                            </div>         
                        </div>

                        <div class="passport-ui flex-between-start">
                            <!-- <div class="u-btn exp-apply" @click="call_expModal"></div> -->
                            <div class="u-btn reward-apply" 
                            :class="{'disabled' : $store.state.userinfo.areaId && ($store.state.task[tid].giftRate == $store.state.task[tid].finishRate) && ($store.state.task[tid_pass].giftRate == $store.state.task[tid_pass].finishRate)}" 
                            @click="apply_ck"></div>   
                        </div>
                    </div>

                </div>

                <div class="t-rank" v-if="nav_index == 2">
                    <div class="wrapper">
                        <div class="rank-info">
                            <p>本次活动增加个人经验值排行榜，</p>
                            <p>活动结束后将根据排名发放额外奖励，</p>
                            <p>排名实时更新，数据延迟请刷新网页或耐心等待结算时间喔~</p>
                        </div>

                        <div class="rank-table">
                            <div class="title-rank"></div>
                            <div class="data-table">
                                <div class="table-head"></div>
                                <div class="table-view">
                                    <vuescroll>
                                        <table>
                                            <tbody>
                                                <tr v-for="(item,idx) in rank_list" :key="'ri-' + idx">
                                                    <th style="width: 120px">
                                                        <div class="i-rank" :class="'r-'+ item.rank"></div>
                                                        <span v-if="item.rank > 3">{{ item.rank ? item.rank : '未上榜' }}</span>                
                                                    </th>
                                                    <th style="width: 160px">{{ area_dic[item.zid] }}</th>
                                                    <th style="width: 170px">
                                                        <div class="player-name text-overflow-1">{{ item.name }}</div>                                       
                                                    </th>
                                                    <th style="width: 170px">{{ item.score }}</th>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </vuescroll>
                                </div>
                                <div class="self-data">
                                    <div class="item-wrapper flex-around-center">
                                        <div class="item" style="width: 120px">{{ self_data.rank != 0 ? self_data.rank : '未上榜' }}</div>
                                        <div class="item" style="width: 160px">{{ area_dic[self_data.zid] }}</div>
                                        <div class="item" style="width: 170px"><div class="player-name text-overflow-1">{{ self_data.name }}</div></div>
                                        <div class="item" style="width: 170px">{{ self_data.score }}</div>
                                    </div>
                                </div>
                            </div>

                            <div class="reward-pannel">
                                <div class="title-reward"></div>
                                <div class="pannel-body">
                                    <div class="list-item" v-for="(item,idx) in rewardArrays" :key="idx">
                                        <div class="label" :class="'r-' + (idx + 1)"></div>
                                        <div class="list flex-center-center">
                                            <div class="reward-pic" v-for="(r,k) in item" :key="'rl-' + k" v-tips="r.giftId">
                                                <game-item :id="r.giftId" :num="r.sendNum" :locked="true"></game-item>
                                            </div> 
                                        </div>
                                    </div>
                                    <p class="notice">*奖励将在活动结束后一周内发放至军师邮件</p>
                                </div>
                                
                            </div>                         
                        </div>
                       
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.title{
    width: 560px;
    height: 161px;
    margin: 0 auto 35px;
    background-image: url(~@/assets/images/title-1.png);
}

.gif-view{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 678px;
    height: 400px;
    margin: 0 auto;

    .layer-border{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        width: 704px;
        height: 426px;
        background-image: url(~@/assets/images/layer-border.png);
    }

    .img{
        position: relative;
        width: 678px;
        height: 400px;
        // background-image: url(~@/assets/images/gif-view.png);

        &::after{
            content: '';
            display: block;
            position: absolute;
            left: 0;
            bottom: 0;
            width: 678px;
            height: 78px;
            background-image: url(~@/assets/images/layer-video.png);
        }

        img{
            width: 100%;
            height: 100%;
        }
    }

    .u-btn.player{
        position: absolute;
        bottom: 10px;
        right: 20px;
        width: 65px;
        height: 63px;
        background-image: url(~@/assets/images/btn-player.png);
        z-index: 4;

        p{
            position: absolute;
            left: -230px;
            top: 50%;
            width: 320px;
            transform: translateY(-50%);
            color: #848382;
        }
    }
}

.intro{
    margin-top: 25px;
    padding: 0 40px;
    line-height: 1.6;
    color: #d4c7a8;
}

.pass-599{
    .pass-img{
        position: relative;
        width: 715px;
        height: 424px;
        margin: -75px 0 0 26px;
        background-image: url(~@/assets/images/img-pass.png);

        .detail{
            position: absolute;
            top: 242px;
            right: 85px;
            width: 175px;
            height: 40px;
            background-image: url(~@/assets/images/btn-detail.png);
        }
    }

    .apply-599{
        position: relative;
        width: 328px;
        height: 80px;
        margin: -50px auto 0;
        background-image: url(~@/assets/images/btn-buy-599.png);
    }
}

.exp-pannel{
    position: relative;
    z-index: 2;

    .t-exp{
        width: 733px;
        height: 1130px;
        margin-top: 100px;
        margin-left: 17px;
        padding-top: 50px;
        box-sizing: border-box;
        background-image: url(~@/assets/images/pannel-main.png);
    }

    .t-rank{
        width: 733px;
        height: 1420px;
        margin-top: 100px;
        margin-left: 17px;
        padding-top: 50px;
        box-sizing: border-box;
        background-image: url(~@/assets/images/pannel-main_rank.png);        
    }

    .wrapper{
        width: 674px;
        margin-left: 22px;
    }

    .tab-hd{
        display: flex;
        justify-content: center;
        position: absolute;
        top: -65px;
        left: 37px;

        .tab-btn{
            width: 329px;
            height: 79px;
            margin: 0 5px;

            &.t-1{
                background-image: url(~@/assets/images/tab-1.png);
                &.active{
                   background-image: url(~@/assets/images/tab-1_act.png); 
                }
            }

            &.t-2{
                background-image: url(~@/assets/images/tab-2.png);
                &.active{
                   background-image: url(~@/assets/images/tab-2_act.png); 
                }                
            }            
        }
    }
    
    &::before{
        display: block;
        content: '';
        position: absolute;
        bottom: -70px;
        right: 40px;
        width: 176px;
        height: 189px;
        background-image: url(~@/assets/images/layer-c3.png);
        z-index: 1;
        animation: npc 2s ease-in-out infinite;
    }

    .m-exp{
        width: 636px;
        height: 182px;
        padding: 15px 10px 0;
        margin: 0 auto;
        box-sizing: border-box;
        background-image: url(~@/assets/images/bg-exp-view.png);
    }

    .data-info{
        padding: 0 5px;
        color: #8d452c;
    }

    .u-btn.score {
        position: relative;
        width: 145px;
        height: 30px;
        background-image: url(~@/assets/images/btn-query.png);
    }

    .u-btn.u-rule {
        position: relative;
        width: 88px;
        height: 23px;
        background-image: url(~@/assets/images/btn-rule.png);
    }
    
    .exp-bar {
        position: relative;
        width: 608px;
        height: 35px;
        margin: 30px auto 20px;
        background-image: url(~@/assets/images/exp-bar.png);
    }

    .bar {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 608px;
        height: 31px;
        transform: translate(-50%,-50%);       
        /* background-image: url(~@/assets/images/bar.png);
        background-size: 690px auto; */
        /* border-radius: .6rem; */
    }

    .bar-rate{
        width: 0;
        height: 31px;
        background: linear-gradient(to right,#da6b40,#b1593d);
        // background-image: url(~@/assets/images/bar.png);
        // background-size: 612px auto;    
    }

    .time-info{
        display: flex;
        justify-content: space-between;
        margin: 20px auto 35px;
        font-size: 22px;
        color: #ad5e49;
    }

    // .time-info.over{
    //     justify-content: center;
    // }    

}

.passport-view{
    margin-top: 26px;

    .icon-lock{
        position: absolute;
        width: 35px;
        height: 36px;
        background-image: url(~@/assets/images/icon-lock.png);
        z-index: 4;
    }

    .table-head{
        position: relative;
        width: 636px;
        height: 56px;
        margin: 0 auto;
        background-image: url(~@/assets/images/table-head.png);

        .icon-lock{
            right: 10px;
            top: 5px;
        }
    }

    .data-table{
        width: 636px;
        margin: 0 auto;

        table {
            position: relative;
            width: 100%;
            font-size: 24px;
            border-collapse:collapse;
        }

        table tr {
            height: 110px;
            //border: 1px solid #e2cdab; 
        }

        table th{
            border: 1px solid #c4a97e; 
        }

        table .exp {
            width: 200px;
            color: #8b5441;
            background-color: #dac195;
        }

        table .r{
            background-color: #dac195;
        }

        table .r-ex{
            background-color: #e0d0aa;
        }

        table .r{
            width: 201px;
        }

        table .r-ex{
            width: 230px;
        }

        .r-ex{
            .icon-lock{
                right: -5px;
                top: -5px;
            }
        }

        table .reward-pic{
            position: relative;
            width: 68px;
            height: 68px;
            margin: 0 auto;
        }

        .reward-pic.dismiss::after{
            display: block;
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, .6);
            background-image: url(~@/assets/images/icon-get.png);
            background-size: 43px auto;
            background-position: center;
            background-repeat: no-repeat;
        }

    }
}

.page.u-btn{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width:  25px;
    height: 43px;
    background-repeat: no-repeat;
}
.page.u-btn.prev{
    left: -100px;
    background-image: url(~@/assets/images/btn-prev.png);
}
.page.u-btn.next{
    right: -100px;
    background-image: url(~@/assets/images/btn-next.png);
}

.pages-ui{
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    width: 200px;
    margin: 35px auto;
    color: transparent;
}

.page-item{
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    cursor: pointer;
    background-image: url(~@/assets/images/nav-item.png);
}

.page-item.act{
    background-image: url(~@/assets/images/nav-act.png);
}

.passport-ui{
    display: flex;
    justify-content: center;
    position: absolute;
    left: 0;
    bottom: 74px;
    width: 100%;
    padding: 0 46px;
    box-sizing: border-box;

    .u-btn{
        width: 270px;
        height: 82px;

        &.exp-apply{
            background-image: url(~@/assets/images/btn-buy.png);
        }

        &.reward-apply{
            background-image: url(~@/assets/images/btn-apply_main.png);
        }
    }
}

// rank
.rank-info{
    margin-bottom: 20px;
    text-align: center;
    font-size: 22px;
    color: #4a2f1f;
}

.title-rank{
    width: 638px;
    height: 48px;
    margin: 0 auto 7px;
    background-image: url(~@/assets/images/title-rank.png);
}

.rank-table{
    .table-head{
        width: 620px;
        height: 40px;
        margin: 0 auto;
        background-image: url(~@/assets/images/table-head_rank.png);        
    }

    .data-table{
        position: relative;
        width: 620px;
        height: 290px;
        margin: 0 auto; 
        background-color: #d8c097;       
    }

    .table-view{
        position: relative;
        width: 100%;
        height: 170px;
        margin: 0 auto;
        color: #63432f;
        
        table{
            width: 100%;
        }

        .i-rank{
            display: inline-block;
            margin: 0 auto;
            &.r-1{
                width: 45px;
                height: 35px;
                background-image: url(~@/assets/images/1st.png);  
            }

            &.r-2{
                width: 35px;
                height: 37px;
                background-image: url(~@/assets/images/2nd.png);  
            }
            
            &.r-3{
                width: 34px;
                height: 38px;
                background-image: url(~@/assets/images/3rd.png);  
            }            
        }
    }

    .self-data{
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        width: 626px;
        height: 62px;
        line-height: 62px;
        background-image: url(~@/assets/images/self.png);
        text-align: center;
        color: #63432f;
    }
}

.reward-pannel{
    margin-top: 35px;

    .title-reward{
        width: 638px;
        height: 48px;
        margin: 0 auto 7px;
        background-image: url(~@/assets/images/title-reward.png);        
    }

    .pannel-body{
        width: 638px;
        height: 760px;
        margin: 0 auto;
        padding-top: 30px;
        box-sizing: border-box;
        background-color: #d8c097;

        .notice{
            text-align: center;
        }
        
        .label{
            width: 100%;
            height: 25px;
            margin-bottom: 12px;
            background-position: center;
            background-repeat: no-repeat;

            @for $i from 1 through 5 {
                &.r-#{$i} {
                    background-image: url(~@/assets/images/r-#{$i}.png);     
                }
            }
        }

        .list-item{
            margin-bottom: 30px;
        }

        .reward-pic{
            width: 69px;
            height: 69px;
            margin: 0 15px;
            border: 2px solid #b88f64;
        }
    }
}
</style>

<script>
import {
    apiTaskApply,
    apiRankList,
} from '@/api/index';

import area_dic from '@/components/areadic.js';

import rewardArrays from '@/data/gifts';

export default {
    data (){
        return {
            max_exp : 48000,
            now_page : 0,
            perpage : 5,
            tid : 't01',
            tid_pass : 't02',
            nav_index : 1,
            rank_list : [],
            self_data :{},
            area_dic,
            rewardArrays,
        }
    },
    mounted(){
        this.fetch_rank();
    },
    methods : {
        exp_result (){
            let vm = this;
            return vm.$store.state.login ? Math.min( (vm.$store.state.userinfo.buy +  vm.$store.state.userinfo.killScore) ,  vm.max_exp) : 0;
        },
        prev (){
            return this.now_page = Math.max(0,--this.now_page)
        },
        next (){
            return this.now_page = Math.min(3,++this.now_page)
        },
        page (index){
            return this.now_page = index;
        },
        max_format(){
            return Math.min(this.$store.state.task[this.tid].rate/this.max_exp * 100, 100);
        },
        buy_599pass(){
            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.areaId){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }

            if((this.$store.state.userinfo.uflag & 2) == 2)return this.$msg_modal('您已购买');

            this.$pass_comfirm();
        },
        apply_ck (){
            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.areaId){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }

            apiTaskApply({code : 1}).then(
                res => {
                    this.$msg_modal('领取成功~');
                    this.$update_evt();
                },
                rej => {
                    this.$msg_modal(rej.message);
                }
            )
        },
        call_expModal(){
            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.areaId){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }
            
            this.$exp_modal();
        },
        query_score(){
            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.areaId){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }
            
            this.$score_modal();
        },
        fetch_rank(){
            apiRankList().then(
                res => {
                    let temp = res.data;                   
                    this.self_data = (temp.length && this.$store.state.userinfo.areaId) ? temp[temp.length - 1] : {};
                    this.rank_list = this.$store.state.userinfo.areaId ? temp.slice(0, -1) : temp;
                },
            )
        },               
    }
}
</script>